import React from 'react';

import { formatMetrics } from 'components/ai/assistant/metrics/helpers';
import { AI_HTML_OPTIONS } from 'components/ai/html';
import type { Metrics } from 'components/ai/assistant/types';
import LoadingSpinner from 'components/ui/loading_spinner';
import SanitizedHTML from 'components/ui/sanitized_html';

interface Props {
  loading: boolean;
  error: boolean;
  errorMessage: string;
  summary: string;
  metrics: Metrics | null;
  emptyMessage?: string;
}

export default function SummaryBody({ loading, error, errorMessage, summary, metrics, emptyMessage }: Props) {
  const formattedMetrics = formatMetrics(metrics);

  return (
    <div className="d-flex flex-column flex-grow-1">
      <div className="flex-grow-1">
        {loading && <LoadingSpinner size="md" skipTopBuffer />}
        {!loading && error &&
          <div className="text-muted">{errorMessage}</div>
        }
        {!loading && !error && summary &&
          <SanitizedHTML className="ai-assistant-prose" html={summary} {...AI_HTML_OPTIONS} />
        }
        {!loading && !error && !summary && emptyMessage &&
          <div className="text-muted">{emptyMessage}</div>
        }
      </div>
      {formattedMetrics &&
        <div className="text-muted fs-xs mt-auto pt-3">{formattedMetrics}</div>
      }
    </div>
  );
}
